__turbopack_context__.v({
  "content": "ComponentDetail-module-scss-module__lLeM9G__content",
  "stickyActions": "ComponentDetail-module-scss-module__lLeM9G__stickyActions",
});
